var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 26.05 28.51"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m18.03 19.64-.08 7a.27.27 0 0 0 .46.19l6.45-6.91a.27.27 0 0 0-.2-.45l-6.36-.07a.25.25 0 0 0-.27.24"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M24.78 3.46h-8.94a2.6 2.6 0 0 1 0 .4 2.86 2.86 0 0 1-5.71 0 2.6 2.6 0 0 1 0-.4H1.19a.27.27 0 0 0-.27.27v23.51a.27.27 0 0 0 .27.27h16.42a.25.25 0 0 0 .2-.09l7.09-7.78a.24.24 0 0 0 .07-.18V3.73a.27.27 0 0 0-.19-.27"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13.02,
  cy: 3.85,
  r: 2.85,
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
})));
export { SvgNote as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI2LjA1IDI4LjUxIj4KICAgIDxwYXRoIGQ9Ik0zMDMuNTgsMTgzLjVsLS4wOCw3YS4yNy4yNywwLDAsMCwuNDYuMTlsNi40NS02LjkxYS4yNy4yNywwLDAsMC0uMi0uNDVsLTYuMzYtLjA3QS4yNS4yNSwwLDAsMCwzMDMuNTgsMTgzLjVaIgogICAgICAgICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI4NS41NSAtMTYzLjg2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIvPgogICAgPHBhdGggZD0iTTMxMC4zMywxNjcuMzJoLTguOTRhMi41OCwyLjU4LDAsMCwxLDAsLjQsMi44NiwyLjg2LDAsMCwxLTUuNzEsMCwyLjU4LDIuNTgsMCwwLDEsMC0uNGgtOC45NGEuMjcuMjcsMCwwLDAtLjI3LjI3VjE5MS4xYS4yNy4yNywwLDAsMCwuMjcuMjdoMTYuNDJhLjI1LjI1LDAsMCwwLC4yLS4wOWw3LjA5LTcuNzhhLjI0LjI0LDAsMCwwLC4wNy0uMThWMTY3LjU5QS4yNy4yNywwLDAsMCwzMTAuMzMsMTY3LjMyWiIKICAgICAgICAgIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0yODUuNTUgLTE2My44NikiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiLz4KICAgIDxjaXJjbGUgY3g9IjEzLjAyIiBjeT0iMy44NSIgcj0iMi44NSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIKICAgICAgICAgICAgc3Ryb2tlLXdpZHRoPSIyIi8+Cjwvc3ZnPg==";